/*
 * @Author: Json Chen
 * @Date: 2021-06-18 18:20:44
 * @LastEditTime: 2022-06-02 17:50:33
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/SelectObjectAsValue/index.tsx
 */
import { Select } from 'antd';
import _ from 'lodash';
import React from 'react';

/**
 *
 *
 * @param {
 *   value: ;
 *   valueKey?: string;
 *   labelKey?: string;
 *   objectAsValue?: boolean;
 *   children: any;
 *   onChange: (value: any) => void;
 * }
 *
 * value 新增Object类型,在onChange时可直接将对象赋值给value
 *
 * valueKey - 原对象选择的后读取Object内的key
 * labelKey - 展示的Object的key
 * objectAsValue - value是否使用对象类型
 *
 * @returns 封装后的Select组件
 */

interface Obj {
  [propName: string]: any;
}
const SelectObjectAsValue = ({
  value,
  onChange,
  valueKey = 'value',
  labelKey = 'label',
  children,
  objectAsValue,
  options,
  mode,
  disabled,
  ...params
}: {
  value?: string | Obj | Array<Obj> | any;
  valueKey?: string;
  labelKey?: string;
  objectAsValue?: boolean;
  options: any;
  children?: any;
  mode?: 'multiple' | 'tags';
  onChange?: (value: any) => void;
  disabled?: boolean;
  [propsName: string]: any;
}) => {
  const _onChange = (val: string | Array<string>) => {
    // TODO : 深层引用key未测试
    if (objectAsValue) {
      if (mode === 'multiple') {
        const values = val as Array<string>;
        const allSelect = values.reduce((pre, now) => {
          const optionsFilter = options.filter(
            (item) => now === _.get(item, valueKey),
          );
          if (optionsFilter.length) {
            return pre.concat(optionsFilter);
          }
          return pre;
        }, []);
        onChange(allSelect);
      } else {
        onChange(options.find((item) => _.get(item, valueKey) === val));
      }
    } else {
      onChange(val);
    }
  };

  const multipleValue =
    mode === 'multiple' ? (value || []).map((item) => item.uuid) : '';

  return (
    <Select
      {...params}
      disabled={disabled}
      mode={mode}
      options={options.map((item) => ({
        label: objectAsValue ? _.get(item, labelKey) : item.label,
        value: objectAsValue ? _.get(item, valueKey) : item.value,
      }))}
      value={
        mode === 'multiple'
          ? multipleValue
          : objectAsValue
          ? _.get(value, valueKey, undefined)
          : value
      }
      onChange={_onChange}>
      {children}
    </Select>
  );
};

export default SelectObjectAsValue;
